import type { Message } from '#entities/message'
import { messageEditEventBus } from './message-edit-event-bus'

export function useTriggerMessageEdit() {
  return (message: Message) => messageEditEventBus.emit(message.chatId, message)
}
